import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../lib/auth';
import { useStore } from '../lib/store';

/** Pages for admins only (the Rule Editor); everybody else gets a short explanation. */
export function AdminOnly({ children }: { children: ReactNode }) {
  const { admin } = useStore(auth);
  if (admin) return <>{children}</>;
  return (
    <div className="page narrow">
      <div className="card stack">
        <h1>Admins only</h1>
        <p className="muted">Custom rules are made by admins and published as game modes that everybody can play.</p>
        <div className="row gap wrap">
          <Link to="/play/setup" className="btn primary">Pick a game mode</Link>
          <Link to="/settings" className="btn ghost">Settings</Link>
        </div>
      </div>
    </div>
  );
}
